import { css } from 'styled-components';
import { TIMINGS } from './constants';

export const pulseAnimation = css`
  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.45;
    }
  }
`;

export const fadeInKeyframes = `
  opacity: 0;
  animation: fadeIn ${TIMINGS.transitionMedium} ease forwards;
`;
